import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import DualList from '../../components/pages/DualList';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportAdminGeneralBranch extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          { I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE13' /* Administração */) },
      { value: I18n.t('BEE14' /* Gerais */) },
      { value: I18n.t('BEE16' /* Filiais */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE82' /* Código */),
        value: 'code',
      }, {
        label: I18n.t('BEE83' /* Nome */),
        value: 'name',
      }, {
        label: I18n.t('BEE112' /* Empresa */),
        value: 'company.companyName',
      }, {
        label: I18n.t('BEE85' /* CNPJ */),
        value: 'cnpj',
      }, {
        label: I18n.t('BEE86' /* E-mail */),
        value: 'email',
      }, {
        label: I18n.t('BEE53' /* Cidade */),
        value: 'city',
      }, {
        label: I18n.t('BEE87' /* Estado */),
        value: 'state',
      }, {
        label: I18n.t('BEE88' /* País */),
        value: 'country',
      }, {
        label: I18n.t('BEE1664' /* Limite de Produto por Onda */),
        value: 'limitProductsWave',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },
    ];

    this.state = {
      selected: [],
      codeFrom: '',
      codeTo: '',
      nameFrom: '',
      nameTo: '',
      companyNameFrom: '',
      companyNameTo: '',
      cnpjFrom: '',
      cnpjTo: '',
      emailFrom: '',
      emailTo: '',
      cityFrom: '',
      cityTo: '',
      stateFrom: '',
      stateTo: '',
      countryFrom: '',
      countryTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value, label) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      companyNameFrom,
      companyNameTo,
      cnpjFrom,
      cnpjTo,
      emailFrom,
      emailTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
      countryFrom,
      countryTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['companyName', { type: 'between', value: [companyNameFrom, companyNameTo] }],
      ['cnpj', { type: 'between', value: [cnpjFrom, cnpjTo] }],
      ['email', { type: 'between', value: [emailFrom, emailTo] }],
      ['city', { type: 'between', value: [cityFrom, cityTo] }],
      ['state', { type: 'between', value: [stateFrom, stateTo] }],
      ['country', { type: 'between', value: [countryFrom, countryTo] }],
    ]);

    this.props.generateReport(I18n.t('BEE16' /* Filiais */).toLowerCase(), 'xlsx', location.pathname, headers, filters);
  };

  /* onGeneratePdf = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      companyNameFrom,
      companyNameTo,
      cnpjFrom,
      cnpjTo,
      emailFrom,
      emailTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
      countryFrom,
      countryTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map(it => ({ ...(this.options.find(itb => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['companyName', { type: 'between', value: [companyNameFrom, companyNameTo] }],
      ['cnpj', { type: 'between', value: [cnpjFrom, cnpjTo] }],
      ['email', { type: 'between', value: [emailFrom, emailTo] }],
      ['city', { type: 'between', value: [cityFrom, cityTo] }],
      ['state', { type: 'between', value: [stateFrom, stateTo] }],
      ['country', { type: 'between', value: [countryFrom, countryTo] }],
    ]);

    this.props.generateReport(I18n.t('BEE16'  Filiais ).toLowerCase(), 'pdf', location.pathname, headers, filters);
  } */

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      companyNameFrom,
      companyNameTo,
      cnpjFrom,
      cnpjTo,
      emailFrom,
      emailTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
      countryFrom,
      countryTo,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE16' /* Filiais */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: codeFrom, to: codeTo },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE82' /* Código */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: nameFrom, to: nameTo },
                    { from: 'nameFrom', to: 'nameTo' },
                    `${I18n.t('BEE83' /* Nome */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  formContext.createInputRange(
                    { from: companyNameFrom, to: companyNameTo },
                    { from: 'companyNameFrom', to: 'companyNameTo' },
                    `${I18n.t('BEE112' /* Empresa */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  formContext.createInputRange(
                    { from: cnpjFrom, to: cnpjTo },
                    { from: 'cnpjFrom', to: 'cnpjTo' },
                    `${I18n.t('BEE85' /* CNPJ */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  formContext.createInputRange(
                    { from: emailFrom, to: emailTo },
                    { from: 'emailFrom', to: 'emailTo' },
                    `${I18n.t('BEE86' /* E-mail */)}:`,
                    { from: '', to: 'Z'.repeat(80) },
                  ),
                  formContext.createInputRange(
                    { from: cityFrom, to: cityTo },
                    { from: 'cityFrom', to: 'cityTo' },
                    `${I18n.t('BEE53' /* Cidade */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  formContext.createInputRange(
                    { from: stateFrom, to: stateTo },
                    { from: 'stateFrom', to: 'stateTo' },
                    `${I18n.t('BEE87' /* Estado */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  formContext.createInputRange(
                    { from: countryFrom, to: countryTo },
                    { from: 'countryFrom', to: 'countryTo' },
                    `${I18n.t('BEE88' /* País */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <>
            <OneClickButton
              type="button"
              style={{ width: 'auto', padding: 10 }}
              className="btn btn-primary p-5 m-5"
              onClick={this.onGenerateSpreadsheet}
            >
              {I18n.t('BEE544' /* Gerar Planilha */)}
            </OneClickButton>
            {/* <button
              type="button"
              style={{ width: 'auto', padding: 10 }}
              className="btn btn-secondary p-5 m-5"
              onClick={this.onGeneratePdf}
            >
              {I18n.t('BEE545'  Gerar PDF )}
            </button> */}
          </>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (nameDoc, type, route, columns, filters) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportAdminGeneralBranch);
